import { useQuery } from '@tanstack/react-query';
import { get } from '../../../../shared/api/apiService';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { DIAM_API_PATH } from '../../diamApi';
import { InvitationAcceptanceRequestState } from './types';

export async function acceptTeamInvitation(
  diamApiUrl: string,
  acceptanceToken: string,
): Promise<boolean> {
  await get<void>('/public/invitations/accept', diamApiUrl, '', {
    params: { token: acceptanceToken },
  });

  return true;
}

export function useAcceptInvitation(
  acceptanceToken: string | null,
): InvitationAcceptanceRequestState {
  const { apiUrl } = useApiEssentials(DIAM_API_PATH);

  return useQuery({
    queryKey: ['diam', 'invitation-acceptance', acceptanceToken],
    queryFn: () => acceptTeamInvitation(apiUrl, acceptanceToken ?? ''),
    enabled: Boolean(acceptanceToken),
    retry: false,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
}
